import { Component } from '@angular/core';

@Component({
  selector: 'era-pane',
  templateUrl: './pane.component.html',
})
export class PaneComponent {}
